import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DataSourceDefDTO, MenuDTO, MenuType } from '../../../../../system/system-dtos';

@Component({
  selector: 'app-data-source-switcher',
  templateUrl: './data-source-switcher.component.html',
  styleUrls: ['./data-source-switcher.component.scss'],
  standalone: false,
})
export class DataSourceSwitcherComponent implements OnInit {
  @Input() menu: MenuDTO;

  @Input() public mode: number;

  public options: DataSourceOption[];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.determineOptions();
      }
    });
    this.determineOptions();
  }

  private determineOptions() {
    this.options = this.menu.entityGroup.dataSources.map((value: DataSourceDefDTO, index: number) => ({
      title: value.definition.title,
      type: value.type,
      index,
    }));
  }

  onModelChange() {
    if (this.menu.entityGroup.dataSources[this.mode].type == MenuType.TICKER) {
      this.router.navigate([`./v2/${this.menu.code}ticker`], {
        relativeTo: this.route.parent,
        queryParams: {
          ...this.route.snapshot.queryParams,
          order: undefined,
          tab: undefined,
          _mode: this.mode,
        },
      });
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          ...this.route.snapshot.queryParams,
          order: undefined,
          tab: undefined,
          _mode: this.mode,
        },
      });
    }
  }
}

export interface DataSourceOption {
  title: string;
  type: MenuType;
  index: number;
}
